export default __webpack_public_path__ + "static/media/tools.af5d9b86.jpg";